/* eslint-disable react/require-default-props */
import { TradingPanel } from '@trading-ui/core';
import { TradingDatagrid } from '@trading-ui/tables';
import { useTranslation } from 'react-i18next';

import type { Plant } from '@/interfaces';

import * as styles from './CompanyCupsTable.css';

type CompanyCupsTableProps = {
  columns: any[];
  data: Plant[];
  isLoading: boolean;
  isRefetching: boolean;
  isManager?: boolean;
};

export default function CompanyCupsTable({
  columns,
  data,
  isLoading,
  isRefetching,
  isManager = false,
}: CompanyCupsTableProps) {
  const { t } = useTranslation();

  // Manager doesn't have tabs, so table can be taller
  const tableHeight = isManager ? 'calc(50vh - 150px)' : 'calc(50vh - 180px)';

  return (
    <TradingPanel className={styles.root}>
      <div className={styles.tableContainer}>
        <TradingDatagrid
          tableHeight={tableHeight}
          columnsTable={columns}
          dataTable={data}
          flexLayout
          keepSelectedRowsOnPageChange={false}
          columnOrder={[]}
          stickyColumns={{
            identifier: 'left',
            edit: 'right',
            delete: 'right',
          }}
          isLoadingMore={isRefetching || isLoading}
          noDataMessage={isRefetching || isLoading ? '' : t('settings.companyDetailsTab.companyCups.emptyMessage')}
        />
      </div>
    </TradingPanel>
  );
}
